import React from 'react';

export interface UserSearchDetails {
	selectionType?: string;
	selectedValue?: string | number;
}

interface IUserDetailsContext {
	selectedUser: any;
	userSearchDetails: UserSearchDetails;
	setUserSearchDetails: (selectedUser: UserSearchDetails) => void;
	handleParseUserDetails: () => UserSearchDetails;
	setSelectedUser: (selectedUser: any) => void;
}

const UserDetailsContext = React.createContext<IUserDetailsContext>({} as IUserDetailsContext);

export default UserDetailsContext;
